module.exports = __webpack_public_path__ + "img/atlas-logo.cf541cd6.png";